<script setup lang="ts">

import Wrapper                 from "../../Layouts/Wrapper.vue";
import Container               from "../../CommonComponents/Container.vue";
import Section                 from "../../CommonComponents/Section.vue";
import SectionTitle            from "../../CommonComponents/SectionTitle.vue";
import __                      from "../../../Utils/tranlation";
import { useForm, usePage }    from "@inertiajs/vue3";
import { reactiveForm }        from "../../../Utils/reactiveForm";
import { onMounted }           from "vue";
import { handleValidateForms } from "../../../Utils/helpers";
import AlertDanger             from "../../CommonComponents/AlertDanger.vue";
import ValidateFormErrorText   from "../../CommonComponents/ValidateFormErrorText.vue";
import FormErrorText           from "../../CommonComponents/FormErrorText.vue";

type TypeProps = {
    title? : string,
    svg_qr_code_image? : string,
    svg_qr_code_image_name? : string,
    png_qr_code_image? : string,
    png_qr_code_image_name? : string,
};

defineProps<TypeProps>();

const form = useForm({
    _token: usePage().props.csrf_token,
    url: null,
    image: null,
    error_qr_code: null,
    is_dynamic_qr_code: true,
    name: null,
});

onMounted(() => {
    handleValidateForms();
});
</script>

<template>
    <Wrapper :title>
        <template #main>
            <Section>
                <Container>
                    <SectionTitle class="mb-6">
                        {{ __('text_title') }}
                    </SectionTitle>

                    <AlertDanger :error="form.errors.error_qr_code"></AlertDanger>

                    <form @submit.prevent="reactiveForm($event, form, $event.target as HTMLElement, 'dynamic-qr-code.store')"
                          class="flex flex-col gap-y-6 max-w-sm mx-auto needs-validation"
                          novalidate>

                        <div>
                            <label for="name"
                                   class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {{ __('text_name') }}
                            </label>

                            <input type="text" id="name" v-model="form.name"
                                   class="bg-gray-50 border border-gray-300 text-gray-900
                                           text-sm rounded-lg focus:ring-blue-500
                                           focus:border-blue-500 block w-full p-2.5
                                           dark:bg-gray-700 dark:border-gray-600
                                           dark:placeholder-gray-400 dark:text-white
                                           dark:focus:ring-blue-500 dark:focus:border-blue-500"/>
                        </div>

                        <div>
                            <label for="url"
                                   class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {{ __('text_url') }}
                            </label>

                            <input type="text" id="url" v-model="form.url"
                                   class="bg-gray-50 border border-gray-300 text-gray-900
                                           text-sm rounded-lg focus:ring-blue-500
                                           focus:border-blue-500 block w-full p-2.5
                                           dark:bg-gray-700 dark:border-gray-600
                                           dark:placeholder-gray-400 dark:text-white
                                           dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                   placeholder="http(s)://example.com"
                                   required/>

                            <FormErrorText :error="__('error_url')"></FormErrorText>
                            <ValidateFormErrorText :error="form.errors.url"></ValidateFormErrorText>
                        </div>

                        <div>
                            <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                   for="qr-code-logo">
                                {{ __('text_image') }}
                            </label>

                            <input class="block w-full text-sm text-gray-900 border border-gray-300
                                          rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400
                                          focus:outline-none dark:bg-gray-700 dark:border-gray-600
                                          dark:placeholder-gray-400 p-2.5"
                                   v-on:change="form.image = ($event.target as object).files[0]"
                                   aria-describedby="user_avatar_help"
                                   id="qr-code-logo"
                                   type="file">

                            <ValidateFormErrorText :error="form.errors.image"></ValidateFormErrorText>
                        </div>

                        <input type="hidden" v-model="form.is_dynamic_qr_code">

                        <button type="submit"
                                :disabled="form.processing"
                                class="text-white bg-blue-700
                                       hover:bg-blue-800 focus:ring-4 focus:outline-none
                                       focus:ring-blue-300 font-medium rounded-lg
                                       text-lg w-full sm:w-auto px-5 py-2.5 text-center
                                       dark:bg-blue-600 dark:hover:bg-blue-700
                                       dark:focus:ring-blue-800">
                            {{ __('text_submit') }}
                        </button>
                    </form>

                    <div v-if="svg_qr_code_image"
                         class="flex items-center justify-center flex-wrap gap-3 mt-5">
                        <a class="text-white bg-green-700 hover:bg-green-800 focus:ring-4
                                  focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5
                                  dark:bg-green-600 dark:hover:bg-green-700 focus:outline-none
                                  dark:green:ring-blue-800"
                           :href="svg_qr_code_image" :download="svg_qr_code_image_name">
                            {{ __('text_download_img_svg') }}
                        </a>

                        <a v-if="png_qr_code_image_name"
                            class="text-white bg-green-700 hover:bg-green-800 focus:ring-4
                                  focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5
                                  dark:bg-green-600 dark:hover:bg-green-700 focus:outline-none
                                  dark:green:ring-blue-800"
                           :href="png_qr_code_image" :download="png_qr_code_image_name">
                            {{ __('text_download_img_png') }}
                        </a>
                    </div>

                    <div v-if="svg_qr_code_image"
                         class="flex items-center justify-center flex-wrap gap-5 mt-5">
                        <img class="max-w-3xl w-full h-full" :src="svg_qr_code_image" alt="">
                    </div>
                </Container>
            </Section>
        </template>
    </Wrapper>
</template>

<style scoped>

</style>
